import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { PoleDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-pole',
  templateUrl: './pole.component.html',
  styleUrls: ['./pole.component.scss'],
})
export class PoleComponent implements OnChanges {
  poleForm: FormGroup;
  poleFormArray: FormGroup;
  control = new FormControl();
  @Input() poles: PoleDto[];
  @Input() routeAnimationsElements: any;
  @Output() pole = new EventEmitter<PoleDto[]>();
  @Output() deletePoleEvent = new EventEmitter<any>();

  selectedPole: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createPoleForm();
  }

  createPoleForm() {
    this.poleForm = this.fb.group({
      PoleName: ['', Validators.required],
      id: null,
    });
    this.poleFormArray = this.fb.group({
      Poles: this.fb.array([]),
    });
    this.setPole();
  }

  // method to display poles
  setPole() {
    const control = this.poleFormArray.controls.Poles as FormArray;
    this.poles.forEach((e) => {
      control.push(
        this.fb.group({
          PoleName: e.PoleName,
          id: e.id,
        })
      );
    });
  }

  // method to add Pole
  addPole(value: PoleDto) {
    const control = this.poleFormArray.controls.Poles as FormArray;
    control.insert(
      0,
      this.fb.group({
        PoleName: value.PoleName,
        id: null,
      })
    );
  }

  selectPole(value) {}

  // method to delete pole from arrary list
  deletePole(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.poleFormArray.controls.Poles as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.poles.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.poles[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: PoleDto) {
    if (this.poleForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.poleFormArray
        .get('Poles')
        ['controls'][this.selectedIndex].patchValue({
          PoleName: formValue.PoleName,
        });
    } else {
      this.addPole(formValue);
    }
    this.selectedIndex = null;
    this.poleForm.reset();
  }

  onEdit(index, value: PoleDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.poleForm.patchValue({ PoleName: value.PoleName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.poleForm.reset();
  }

  onSubmit(formValue: PoleDto[]) {
    this.pole.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deletePoleEvent.emit(this.filteredDelete);
    }
  }
}
